import React from "react";
import "../Image/Image.css";
const Img = () => {
  return (
    <>
      <img src="count.webp" className="imgg" alt="terrace-image" />
    </>
  );
};

export default Img;
